<form #prodForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/product']">Products</a> > {{ product.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(prodForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Name</mat-label>
            <input #name="ngModel" type="text" matInput name="name" [(ngModel)]="product.name" required>
            <mat-error *ngIf="name.invalid && name.touched">Product Name is required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>HSN/SAC</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedHsn">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onHsnKey($event)" matInput name="hsn_list">
              <mat-option *ngFor="let hsn of filteredHsns" [value]="hsn.id">{{ hsn.hsn_sac }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Category</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedCategory" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keyup)="onCategoryKey($event)" matInput name="category_list">
              <mat-option *ngFor="let category of filteredCategorys" [value]="category.id">{{ category.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Lead Time (Days)</mat-label>
            <input (keypress)="onlyNumber($event)" type="text" maxlength="3" matInput name="lead_time" [(ngModel)]="product.lead_time">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Rate (Rs.)</mat-label>
            <input #rate="ngModel" (keypress)="onlyNumber($event)" type="text" matInput name="rate" [(ngModel)]="product.rate" required>
            <mat-error *ngIf="rate.invalid && rate.touched">Rate is required</mat-error>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="product" [recordId]="product.id"></app-audit-log-viewer>
</form>
